/**
* PlayMode.js
* 
* Created on Oct 2, 2013, 2:17:19 PM
*
* @author Javier Quevedo-Fernandez for Ranj
**/
const PlayMode = {};
export default PlayMode;

PlayMode.AUTO = "auto";
PlayMode.COMMANDS = "commands";
PlayMode.MANUAL = "manual";
